var map = {
	"./": 24,
	"./App": 29,
	"./App.css": 49,
	"./App.jsx": 29,
	"./assets/data/claim": 19,
	"./assets/data/claim.json": 19,
	"./assets/data/content": 20,
	"./assets/data/content-backup": 199,
	"./assets/data/content-backup.json": 199,
	"./assets/data/content.json": 20,
	"./assets/data/menu": 21,
	"./assets/data/menu.json": 21,
	"./assets/data/partner": 22,
	"./assets/data/partner.json": 22,
	"./assets/data/purchase": 23,
	"./assets/data/purchase.json": 23,
	"./assets/dropdown.svg": 247,
	"./assets/fonts/Shopee2021-Bold.ttf": 248,
	"./assets/img/OIC.png": 88,
	"./assets/img/banner/Mobile-01.jpg": 109,
	"./assets/img/banner/Mobile-02.jpg": 249,
	"./assets/img/banner/Mobile-03.jpg": 250,
	"./assets/img/banner/Mobile-04.jpg": 251,
	"./assets/img/banner/Mobile-05.jpg": 252,
	"./assets/img/banner/Mobile-06.jpg": 253,
	"./assets/img/banner/Mobile-07.jpg": 254,
	"./assets/img/banner/Mobile-08.jpg": 255,
	"./assets/img/banner/Mobile-09.jpg": 256,
	"./assets/img/banner/PC-01.jpg": 108,
	"./assets/img/banner/PC-02.jpg": 257,
	"./assets/img/banner/PC-03.jpg": 258,
	"./assets/img/banner/PC-04.jpg": 259,
	"./assets/img/banner/PC-05.jpg": 260,
	"./assets/img/banner/PC-06.jpg": 261,
	"./assets/img/banner/PC-07.jpg": 262,
	"./assets/img/banner/PC-08.jpg": 263,
	"./assets/img/banner/PC-09.jpg": 264,
	"./assets/img/banner_home.png": 265,
	"./assets/img/banner_home_mobile.png": 266,
	"./assets/img/banner_property.png": 267,
	"./assets/img/bg.png": 268,
	"./assets/img/claim/1.png": 114,
	"./assets/img/claim/10.png": 115,
	"./assets/img/claim/11.png": 116,
	"./assets/img/claim/12.png": 117,
	"./assets/img/claim/13.png": 118,
	"./assets/img/claim/14.png": 119,
	"./assets/img/claim/15.png": 120,
	"./assets/img/claim/16.png": 121,
	"./assets/img/claim/17.png": 122,
	"./assets/img/claim/18.png": 123,
	"./assets/img/claim/19.png": 124,
	"./assets/img/claim/2.png": 125,
	"./assets/img/claim/20.png": 126,
	"./assets/img/claim/21.png": 127,
	"./assets/img/claim/22.png": 128,
	"./assets/img/claim/23.png": 129,
	"./assets/img/claim/24.png": 130,
	"./assets/img/claim/25.png": 131,
	"./assets/img/claim/26.png": 132,
	"./assets/img/claim/27.png": 133,
	"./assets/img/claim/28.png": 134,
	"./assets/img/claim/29.png": 135,
	"./assets/img/claim/3.png": 136,
	"./assets/img/claim/30.png": 137,
	"./assets/img/claim/4.png": 138,
	"./assets/img/claim/5.png": 139,
	"./assets/img/claim/6.png": 140,
	"./assets/img/claim/7.png": 141,
	"./assets/img/claim/8.png": 142,
	"./assets/img/claim/9.png": 143,
	"./assets/img/claim/connection_phone__bill.svg": 96,
	"./assets/img/claim/desktop_banner_claim.jpg": 193,
	"./assets/img/claim/mobile_banner_claim.jpg": 194,
	"./assets/img/claim/tel.png": 28,
	"./assets/img/contact/desktop_banner_contact.jpg": 269,
	"./assets/img/contact/mobile_banner_contact.jpg": 270,
	"./assets/img/desktop_banner_cancellations.jpg": 173,
	"./assets/img/desktop_banner_claim.jpg": 174,
	"./assets/img/desktop_banner_contact.jpg": 92,
	"./assets/img/desktop_banner_employee.jpg": 175,
	"./assets/img/desktop_banner_health.jpg": 176,
	"./assets/img/desktop_banner_home.jpg": 177,
	"./assets/img/desktop_banner_liability.jpg": 178,
	"./assets/img/desktop_banner_miscellaneous.jpg": 179,
	"./assets/img/desktop_banner_motor.jpg": 180,
	"./assets/img/desktop_banner_payment.jpg": 93,
	"./assets/img/desktop_banner_personal.jpg": 181,
	"./assets/img/desktop_banner_travel.jpg": 182,
	"./assets/img/down-hovered.png": 271,
	"./assets/img/down.png": 272,
	"./assets/img/employee/1.png": 144,
	"./assets/img/employee/2.png": 145,
	"./assets/img/employee/3.png": 146,
	"./assets/img/health/1.png": 147,
	"./assets/img/health/2.png": 148,
	"./assets/img/highlight.png": 273,
	"./assets/img/home/desktop_banner_home.jpg": 274,
	"./assets/img/home/mobile_banner_home.jpg": 275,
	"./assets/img/house.png": 276,
	"./assets/img/icon/company.png": 149,
	"./assets/img/icon/icon_chat.png": 52,
	"./assets/img/icon/icon_grow.png": 50,
	"./assets/img/icon/icon_product.png": 51,
	"./assets/img/icon/icon_protect.png": 53,
	"./assets/img/icon/individual.png": 90,
	"./assets/img/icon/menu.png": 87,
	"./assets/img/icon/tel.png": 150,
	"./assets/img/liability/1.png": 151,
	"./assets/img/liability/2.png": 152,
	"./assets/img/liability/3.png": 153,
	"./assets/img/liability/4.png": 154,
	"./assets/img/logo.png": 15,
	"./assets/img/miscellaneous/1.png": 155,
	"./assets/img/miscellaneous/2.png": 156,
	"./assets/img/miscellaneous/3.png": 157,
	"./assets/img/mobile_banner_cancellations.jpg": 183,
	"./assets/img/mobile_banner_claim.jpg": 184,
	"./assets/img/mobile_banner_contact.jpg": 94,
	"./assets/img/mobile_banner_employee.jpg": 185,
	"./assets/img/mobile_banner_health.jpg": 186,
	"./assets/img/mobile_banner_home.jpg": 187,
	"./assets/img/mobile_banner_liability.jpg": 188,
	"./assets/img/mobile_banner_miscellaneous.jpg": 189,
	"./assets/img/mobile_banner_motor.jpg": 190,
	"./assets/img/mobile_banner_payment.jpg": 95,
	"./assets/img/mobile_banner_personal.jpg": 191,
	"./assets/img/mobile_banner_travel.jpg": 192,
	"./assets/img/motor/1.png": 158,
	"./assets/img/motor/2.png": 159,
	"./assets/img/partner/AIA.png": 54,
	"./assets/img/partner/AIG.png": 55,
	"./assets/img/partner/AXA.png": 56,
	"./assets/img/partner/Aioi.png": 57,
	"./assets/img/partner/Bangkok.png": 58,
	"./assets/img/partner/CHUBB.png": 59,
	"./assets/img/partner/Charan.png": 60,
	"./assets/img/partner/Cigna.png": 61,
	"./assets/img/partner/Deves.png": 62,
	"./assets/img/partner/Dhipaya.png": 63,
	"./assets/img/partner/FPG.png": 64,
	"./assets/img/partner/Falcon.png": 65,
	"./assets/img/partner/Indara.png": 66,
	"./assets/img/partner/IndaraPLC.png": 67,
	"./assets/img/partner/Jaymart.png": 68,
	"./assets/img/partner/KPI.png": 69,
	"./assets/img/partner/KWG.png": 70,
	"./assets/img/partner/LMG.png": 71,
	"./assets/img/partner/MSIG.png": 72,
	"./assets/img/partner/MuangThai.png": 73,
	"./assets/img/partner/NSI.png": 74,
	"./assets/img/partner/Navakij.png": 75,
	"./assets/img/partner/New India.png": 76,
	"./assets/img/partner/SouthEast.png": 77,
	"./assets/img/partner/Sunday.png": 78,
	"./assets/img/partner/THAIPAIBOON.png": 79,
	"./assets/img/partner/THAIPAT.png": 80,
	"./assets/img/partner/THAISRI.png": 81,
	"./assets/img/partner/TSI.png": 82,
	"./assets/img/partner/Thanachart.png": 83,
	"./assets/img/partner/TokioMarine.png": 84,
	"./assets/img/partner/Tune.png": 85,
	"./assets/img/partner/Viriyah.png": 86,
	"./assets/img/payment/account-backup.png": 160,
	"./assets/img/payment/account.png": 91,
	"./assets/img/payment/desktop_banner_cancellations.jpg": 195,
	"./assets/img/payment/desktop_banner_payment.jpg": 277,
	"./assets/img/payment/mobile_banner_cancellations.jpg": 196,
	"./assets/img/payment/mobile_banner_payment.jpg": 278,
	"./assets/img/personal/1.png": 161,
	"./assets/img/purchase/health/flow_1.jpg": 279,
	"./assets/img/purchase/health/flow_2.jpg": 280,
	"./assets/img/purchase/health/logo.png": 162,
	"./assets/img/purchase/health/qrcode_1.png": 163,
	"./assets/img/purchase/health/qrcode_2.png": 164,
	"./assets/img/purchase/mobile_banner.jpg": 198,
	"./assets/img/purchase/motor/flow_1.jpg": 281,
	"./assets/img/purchase/motor/flow_2.jpg": 282,
	"./assets/img/purchase/motor/flow_3.jpg": 283,
	"./assets/img/purchase/motor/logo.png": 165,
	"./assets/img/purchase/motor/qrcode_1.png": 166,
	"./assets/img/purchase/other/flow_1.jpg": 284,
	"./assets/img/purchase/other/logo.png": 167,
	"./assets/img/purchase/pc_banner.jpg": 197,
	"./assets/img/purchase/saving/flow_1.jpg": 285,
	"./assets/img/purchase/saving/flow_2.jpg": 286,
	"./assets/img/purchase/saving/logo.png": 168,
	"./assets/img/purchase/saving/qrcode_1.png": 169,
	"./assets/img/purchase/travel/flow_1.jpg": 287,
	"./assets/img/purchase/travel/flow_2.jpg": 288,
	"./assets/img/purchase/travel/logo.png": 170,
	"./assets/img/purchase/travel/qrcode_1.png": 171,
	"./assets/img/travel/1.png": 172,
	"./components/banner": 8,
	"./components/banner.jsx": 8,
	"./components/content": 36,
	"./components/content.jsx": 36,
	"./components/footer": 33,
	"./components/footer.jsx": 33,
	"./components/navbar": 45,
	"./components/navbar.jsx": 45,
	"./components/row": 35,
	"./components/row.jsx": 35,
	"./contexts/GlobalContext": 16,
	"./contexts/GlobalContext.jsx": 16,
	"./hooks/listen-for-outside-clicks": 32,
	"./hooks/listen-for-outside-clicks.js": 32,
	"./hooks/use-api": 9,
	"./hooks/use-api.js": 9,
	"./hooks/use-ga-tracker": 44,
	"./hooks/use-ga-tracker.js": 44,
	"./index": 24,
	"./index.css": 99,
	"./index.js": 24,
	"./pages/Purchase": 43,
	"./pages/Purchase.jsx": 43,
	"./pages/cancel": 39,
	"./pages/cancel.jsx": 39,
	"./pages/claims": 37,
	"./pages/claims.jsx": 37,
	"./pages/contact": 40,
	"./pages/contact.jsx": 40,
	"./pages/home": 30,
	"./pages/home.jsx": 30,
	"./pages/payment": 38,
	"./pages/payment.jsx": 38,
	"./pages/policy": 41,
	"./pages/policy.jsx": 41,
	"./pages/product": 34,
	"./pages/product.jsx": 34,
	"./pages/tc": 42,
	"./pages/tc.jsx": 42,
	"./react-app-env.d": 200,
	"./react-app-env.d.ts": 200,
	"./shopeepay_url_dependencies.txt": 291,
	"./utils/pfc": 31,
	"./utils/pfc.ts": 31
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97;